if(!customElements.get('contact-form-modal')){
    customElements.define('contact-form-modal', class ContactFormModal extends HTMLElement {
        constructor(){
            super();
            this.openButton = this.querySelector('[data-modal-open]');
            this.closeButton = this.querySelector('[data-modal-close]');
            this.modal = this.querySelector('dialog');
            this.modalContent = this.modal.querySelector('[data-modal-content]')
            this.modalEmbed = this.modalContent.querySelector('.pxFormGenerator');

            this.openButton.addEventListener('click', this.handleButtonClick.bind(this))
            this.closeButton.addEventListener('click', this.handleCloseButtonClick.bind(this))
        }
        handleButtonClick(e){
            e.preventDefault();
            if(this.modalEmbed == null){
                let otherModal = document.querySelector(`#${this.modal.id.replace('-desktop', '-mobile')}`);
                this.modalContent.innerHTML = otherModal.querySelector('[data-modal-content]').innerHTML;
                this.modalEmbed = this.modal.querySelector('.pxFormGenerator');
            }
            let iframe = this.modal.querySelector('iframe');
            if (iframe) iframe.style.height = '100%';

            // Move dialog to body so it escapes any stacking contexts in the section markup
            this._modalOriginalParent = this.modal.parentNode;
            this._modalNextSibling = this.modal.nextSibling;
            document.body.appendChild(this.modal);

            this._backdrop = document.createElement('div');
            this._backdrop.className = 'contact-form-backdrop';
            this._backdrop.addEventListener('click', this._close.bind(this));
            document.body.appendChild(this._backdrop);

            this.modal.show();
        }
        _close(){
            this.modal.close();
            if (this._backdrop) {
                this._backdrop.remove();
                this._backdrop = null;
            }
            if (this._modalOriginalParent) {
                this._modalOriginalParent.insertBefore(this.modal, this._modalNextSibling || null);
                this._modalOriginalParent = null;
                this._modalNextSibling = null;
            }
        }
        handleCloseButtonClick(e){
            e.preventDefault();
            this._close();
        }
    })
}